export default function LoginHeaderCanceledAccount() {
  return (
    <p className="dark:text-red-500">
      Your subscription is no longer active.
    </p>
  );
}
